/**
 * Normalizes address components to match Vocus Wholesale standards.
 * Based on Vocus Street Address Component and PostCode Standard.
 */

const STREET_TYPE_MAP = {
    // A
    'Access': 'ACCESS',
    'Alley': 'ALLEY',
    'Alleyway': 'ALLEYWAY',
    'Amble': 'AMBLE',
    'Anchorage': 'ANCHORAGE',
    'Approach': 'APPROACH',
    'Arcade': 'ARCADE',
    'Arterial': 'ARTERIAL',
    'Artery': 'ARTERY',
    'Avenue': 'AVE',
    'Ave': 'AVE',
    // B
    'Bank': 'BANK',
    'Barracks': 'BARRACKS',
    'Basin': 'BASIN',
    'Bay': 'BAY',
    'Beach': 'BEACH',
    'Bend': 'BEND',
    'Block': 'BLOCK',
    'Boundary': 'BOUNDARY',
    'Boulevard': 'BLVD',
    'Blvd': 'BLVD',
    'Bowl': 'BOWL',
    'Brace': 'BRACE',
    'Brae': 'BRAE',
    'Branch': 'BRANCH',
    'Brea': 'BREA',
    'Break': 'BREAK',
    'Bridge': 'BRIDGE',
    'Broadway': 'BROADWAY',
    'Brow': 'BROW',
    'Bypass': 'BYPASS',
    'Byway': 'BYWAY',
    // C
    'Causeway': 'CAUSEWAY',
    'Centre': 'CENTRE',
    'Centreway': 'CENTREWAY',
    'Chase': 'CHASE',
    'Circle': 'CIRCLE',
    'Circlet': 'CIRCLET',
    'Circuit': 'CIRCUIT',
    'Cct': 'CIRCUIT',
    'Circus': 'CIRCUS',
    'Close': 'CLOSE',
    'Cl': 'CLOSE',
    'Colonnade': 'COLONNADE',
    'Common': 'COMMON',
    'Community': 'COMMUNITY',
    'Concourse': 'CONCOURSE',
    'Connection': 'CONNECTION',
    'Copse': 'COPSE',
    'Corner': 'CORNER',
    'Corso': 'CORSO',
    'Course': 'COURSE',
    'Court': 'CT',
    'Ct': 'CT',
    'Courtyard': 'COURTYARD',
    'Cove': 'COVE',
    'Creek': 'CREEK',
    'Crescent': 'CRES',
    'Cres': 'CRES',
    'Crest': 'CREST',
    'Crier': 'CRIER',
    'Cross': 'CROSS',
    'Crossing': 'CROSSING',
    'Crossroad': 'CROSSROAD',
    'Crossway': 'CROSSWAY',
    'Cruiseway': 'CRUISEWAY',
    'Cul-de-sac': 'CUL-DE-SAC',
    'Cutting': 'CUTTING',
    // D
    'Dale': 'DALE',
    'Dell': 'DELL',
    'Deviation': 'DEVIATION',
    'Dip': 'DIP',
    'Distributor': 'DISTRIBUTOR',
    'Downs': 'DOWNS',
    'Drive': 'DR',
    'Dr': 'DR',
    'Driveway': 'DRIVEWAY',
    // E
    'Easement': 'EASEMENT',
    'Edge': 'EDGE',
    'Elbow': 'ELBOW',
    'End': 'END',
    'Entrance': 'ENTRANCE',
    'Esplanade': 'ESP',
    'Esp': 'ESP',
    'Estate': 'ESTATE',
    'Expressway': 'EXPRESSWAY',
    'Extension': 'EXTENSION',
    // F
    'Fair': 'FAIR',
    'Fairway': 'FAIRWAY',
    'Firetrack': 'FIRETRACK',
    'Firetrail': 'FIRETRAIL',
    'Flat': 'FLAT',
    'Follow': 'FOLLOW',
    'Footway': 'FOOTWAY',
    'Foreshore': 'FORESHORE',
    'Formation': 'FORMATION',
    'Freeway': 'FREEWAY',
    'Front': 'FRONT',
    'Frontage': 'FRONTAGE',
    // G
    'Gap': 'GAP',
    'Garden': 'GARDEN',
    'Garden(s)': 'GARDEN(S)',
    'Gardens': 'GARDENS',
    'Gate': 'GATE',
    'Gate(s)': 'GATE(S)',
    'Gates': 'GATES',
    'Gateway': 'GATEWAY',
    'Glade': 'GLADE',
    'Glen': 'GLEN',
    'Grange': 'GRANGE',
    'Green': 'GREEN',
    'Ground': 'GROUND',
    'Grove': 'GR',
    'Gr': 'GR',
    'Gully': 'GULLY',
    // H
    'Heath': 'HEATH',
    'Heights': 'HEIGHTS',
    'Highroad': 'HIGHROAD',
    'Highway': 'HWY',
    'Hwy': 'HWY',
    'Hill': 'HILL',
    'Hillside': 'HILLSIDE',
    'House': 'HOUSE',
    // I
    'Interchange': 'INTERCHANGE',
    'Intersection': 'INTERSECTION',
    'Island': 'ISLAND',
    // J
    'Junction': 'JUNCTION',
    'Jnc': 'JUNCTION',
    // K
    'Key': 'KEY',
    'Knoll': 'KNOLL',
    // L
    'Landing': 'LANDING',
    'Lane': 'LN',
    'Ln': 'LN',
    'Laneway': 'LANEWAY',
    'Lees': 'LEES',
    'Line': 'LINE',
    'Link': 'LINK',
    'Little': 'LITTLE',
    'Location': 'LOCATION',
    'Lookout': 'LOOKOUT',
    'Loop': 'LOOP',
    'Lower': 'LOWER',
    // M
    'Mall': 'MALL',
    'Marketland': 'MARKETLAND',
    'Markettown': 'MARKETTOWN',
    'Mead': 'MEAD',
    'Meander': 'MEANDER',
    'Mew': 'MEW',
    'Mews': 'MEWS',
    'Motorway': 'MOTORWAY',
    'Mount': 'MOUNT',
    'Mt': 'MOUNT',
    'Mountain': 'MOUNTAIN',
    // N
    'Nook': 'NOOK',
    'Not Required': 'NOT REQUIRED',
    // O
    'Outlook': 'OUTLOOK',
    'Oval': 'OVAL',
    // P
    'Parade': 'PDE',
    'Pde': 'PDE',
    'Paradise': 'PARADISE',
    'Park': 'PARK',
    'Parklands': 'PARKLANDS',
    'Parkway': 'PARKWAY',
    'Part': 'PART',
    'Pass': 'PASS',
    'Path': 'PATH',
    'Pathway': 'PATHWAY',
    'Peninsula': 'PENINSULA',
    'Piazza': 'PIAZZA',
    'Pier': 'PIER',
    'Place': 'PL',
    'Pl': 'PL',
    'Plateau': 'PLATEAU',
    'Plaza': 'PLAZA',
    'Pocket': 'POCKET',
    'Point': 'POINT',
    'Pt': 'POINT',
    'Port': 'PORT',
    'Promenade': 'PROMENADE',
    'Pursuit': 'PURSUIT',
    // Q
    'Quad': 'QUAD',
    'Quadrangle': 'QUADRANGLE',
    'Quadrant': 'QUADRANT',
    'Quay': 'QUAY',
    'Quay(s)': 'QUAY(S)',
    'Quays': 'QUAYS',
    // R
    'Racecourse': 'RACECOURSE',
    'Ramble': 'RAMBLE',
    'Ramp': 'RAMP',
    'Range': 'RANGE',
    'Reach': 'REACH',
    'Reserve': 'RESERVE',
    'Res': 'RESERVE',
    'Rest': 'REST',
    'Retreat': 'RETREAT',
    'Return': 'RETURN',
    'Ride': 'RIDE',
    'Ridge': 'RIDGE',
    'Ridgeway': 'RIDGEWAY',
    'Rightofway': 'RIGHTOFWAY',
    'Ring': 'RING',
    'Rise': 'RISE',
    'River': 'RIVER',
    'Riverway': 'RIVERWAY',
    'Riviera': 'RIVIERA',
    'Road': 'RD',
    'Rd': 'RD',
    'Road(s)': 'ROAD(S)',
    'Roads': 'ROADS',
    'Roadside': 'ROADSIDE',
    'Roadway': 'ROADWAY',
    'Ronde': 'RONDE',
    'Rosebowl': 'ROSEBOWL',
    'Rotary': 'ROTARY',
    'Round': 'ROUND',
    'Route': 'ROUTE',
    'Row': 'ROW',
    'Rowe': 'ROWE',
    'Rue': 'RUE',
    'Run': 'RUN',
    // S
    'Section': 'SECTION',
    'Service Way': 'SERVICE WAY',
    'Siding': 'SIDING',
    'Slope': 'SLOPE',
    'Sound': 'SOUND',
    'Spur': 'SPUR',
    'Square': 'SQ',
    'Sq': 'SQ',
    'Stairs': 'STAIRS',
    'State Highway': 'STATE HIGHWAY',
    'Station': 'STATION',
    'Stn': 'STATION',
    'Steps': 'STEPS',
    'Stop': 'STOP',
    'Straight': 'STRAIGHT',
    'Strand': 'STRAND',
    'Strip': 'STRIP',
    'Subway': 'SUBWAY',
    // Vocus DIR validates Main.StreetType — full word "STREET" returns DIR-4220; use standard abbr "ST"
    'Street': 'ST',
    'St': 'ST',
    // T
    'Tarn': 'TARN',
    'Terrace': 'TCE',
    'Tce': 'TCE',
    'Thoroughfare': 'THOROUGHFARE',
    'Tollway': 'TOLLWAY',
    'Top': 'TOP',
    'Tor': 'TOR',
    'Tower': 'TOWER',
    'Towers': 'TOWERS',
    'Track': 'TRACK',
    'Trail': 'TRAIL',
    'Trailer': 'TRAILER',
    'Triangle': 'TRIANGLE',
    'Trunkway': 'TRUNKWAY',
    'Turn': 'TURN',
    // U
    'Underpass': 'UNDERPASS',
    'Upper': 'UPPER',
    // V
    'Vale': 'VALE',
    'Valley': 'VALLEY',
    'Viaduct': 'VIADUCT',
    'View': 'VIEW',
    'Village': 'VILLAGE',
    'Villas': 'VILLAS',
    'Vista': 'VISTA',
    // W
    'Wade': 'WADE',
    'Walk': 'WALK',
    'Walkway': 'WALKWAY',
    'Waters': 'WATERS',
    'Way': 'WAY',
    'Wy': 'WAY',
    'West': 'WEST',
    'Wharf': 'WHARF',
    'Wood': 'WOOD',
    'Wynd': 'WYND',
    // Y
    'Yard': 'YARD'
};

const STATE_MAP = {
    'New South Wales': 'NSW',
    'Victoria': 'VIC',
    'Queensland': 'QLD',
    'Western Australia': 'WA',
    'South Australia': 'SA',
    'Tasmania': 'TAS',
    'Australian Capital Territory': 'ACT',
    'Northern Territory': 'NT'
};

const STREET_SUFFIXES = ['NORTH', 'SOUTH', 'EAST', 'WEST', 'CENTRAL', 'UPPER', 'LOWER', 'EXTENSION', 'OFF', 'ON'];

/**
 * Normalizes an Australian address object for Vocus API compatibility.
 * @param {Object} components - The address components
 * @returns {Object} - The normalized components
 */
export const normalizeAddressForVocus = (components) => {
    const {
        streetNumber = '',
        streetName = '',
        streetType = '',
        streetSuffix = '',
        suburb = '',
        state = '',
        postcode = '',
        unitNumber = '',
        unitType = '',
        unitSuffix = '',
        levelNumber = '',
        levelType = '',
        levelSuffix = '',
        lotNumber = '',
        locationId = ''
    } = components;

    // 1. Normalize Street Type (Full Name to Abbreviation)
    let normalizedStreetType = streetType.trim().toUpperCase();
    // Map to Vocus standard names if found
    const matchedType = Object.entries(STREET_TYPE_MAP).find(
        ([full, abbr]) => full.toUpperCase() === normalizedStreetType || abbr.toUpperCase() === normalizedStreetType
    );
    normalizedStreetType = matchedType ? matchedType[1] : normalizedStreetType;
    // Defensive: Google / callers may send "STREET" before map match
    if (normalizedStreetType === 'STREET') normalizedStreetType = 'ST';

    // 2. Normalize State
    let normalizedState = state.trim().toUpperCase();
    const matchedState = Object.entries(STATE_MAP).find(
        ([full, abbr]) => full.toUpperCase() === normalizedState || abbr.toUpperCase() === normalizedState
    );
    normalizedState = matchedState ? matchedState[1] : normalizedState;

    // 3. Vocus Formatting: All Uppercase
    return {
        streetNumber: streetNumber.trim().toUpperCase(),
        streetName: streetName.trim().toUpperCase(),
        streetType: normalizedStreetType,
        streetSuffix: streetSuffix.trim().toUpperCase(),
        suburb: suburb.trim().toUpperCase(),
        city: suburb.trim().toUpperCase(), // Alias for Vocus
        state: normalizedState,
        postcode: postcode.trim().toUpperCase(),
        unitNumber: unitNumber.trim().toUpperCase(),
        Unit1stNumber: unitNumber.trim().toUpperCase(), // Alias for Vocus
        unitType: unitType.trim().toUpperCase(),
        unitSuffix: unitSuffix.trim().toUpperCase(),
        levelNumber: levelNumber.trim().toUpperCase(),
        levelType: levelType.trim().toUpperCase(),
        levelSuffix: levelSuffix.trim().toUpperCase(),
        lotNumber: lotNumber.trim().toUpperCase(),
        locationId: locationId.trim().toUpperCase(),
        // Combined string for display
        fullAddress: `${unitNumber ? unitNumber + '/' : ''}${streetNumber} ${streetName} ${normalizedStreetType}${streetSuffix ? ' ' + streetSuffix : ''}, ${suburb} ${normalizedState} ${postcode}`.toUpperCase()
    };
};

/**
 * Parses Google Maps address_components into our structured format.
 * Works with both Legacy and New (V1) Places API.
 */
export const parseGoogleAddress = (googleComponents, formattedAddress = '') => {
    const components = {
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        state: '',
        postcode: '',
        unitNumber: '',
        unitType: '',
    };

    if (!googleComponents || !Array.isArray(googleComponents)) {
        return normalizeAddressForVocus(components);
    }

    // 1. ITERATE GOOGLE COMPONENTS
    googleComponents.forEach(component => {
        const types = component.types || [];
        const longName = component.long_name || component.longName || '';
        const shortName = component.short_name || component.shortName || '';

        // Street Number & Units.
        // Google's `subpremise` for Australian addresses can include the prefix
        // word ("Unit 85", "U 85", "Apt 12", "Flat 3", "Level 4"). Strip the
        // prefix so we send Vocus a clean alphanumeric ("85", "85A").
        if (types.includes('subpremise')) {
            const stripped = String(longName)
                .trim()
                .replace(/^(unit|u|apt|apartment|flat|fl|suite|ste|level|lvl|lv|shop|sh|villa)\s*[#:.\-]?\s*/i, '')
                .trim();
            components.unitNumber = stripped || longName;
            components.unitType = 'UNIT';
        }
        if (types.includes('street_number')) {
            components.streetNumber = longName;
        }

        // Street Name & Type & Suffix
        if (types.includes('route')) {
            const parts = longName.split(' ');
            if (parts.length > 2) {
                // Check if the last part is a suffix
                const lastPart = parts[parts.length - 1].toUpperCase();
                if (STREET_SUFFIXES.includes(lastPart)) {
                    components.streetSuffix = parts.pop();
                    components.streetType = parts.pop();
                    components.streetName = parts.join(' ');
                } else {
                    components.streetType = parts.pop();
                    components.streetName = parts.join(' ');
                }
            } else if (parts.length > 1) {
                components.streetType = parts.pop();
                components.streetName = parts.join(' ');
            } else {
                components.streetName = longName;
            }
        }

        // AGGRESSIVE SUBURB DETECTION
        const isSuburbType = types.some(t => [
            'locality',
            'sublocality',
            'sublocality_level_1',
            'postal_town',
            'neighborhood',
            'political'
        ].includes(t));

        if (isSuburbType) {
            // Priority 1: 'locality' is the legal suburb in AU
            if (!components.suburb || types.includes('locality')) {
                components.suburb = longName;
            }
        }

        // State & Postcode
        if (types.includes('administrative_area_level_1')) {
            components.state = shortName;
        }
        if (types.includes('postal_code') || types.includes('postal_code_prefix')) {
            components.postcode = longName;
        }
    });

    // 2. ACT INTELLIGENCE FALLBACK
    // Many Canberra addresses (Greenway, Casey, etc.) are returned without Suburb/Postcode by Google
    const isACT = components.state === 'ACT' || (formattedAddress && formattedAddress.includes('Australian Capital Territory'));
    if (isACT && (!components.suburb || !components.postcode)) {
        const full = (formattedAddress || '').toLowerCase();

        // Hardcoded intelligence for known troublesome ACT streets
        const actMap = [
            { street: 'cynthea teague', suburb: 'GREENWAY', postcode: '2900' },
            { street: 'overall ave', suburb: 'CASEY', postcode: '2913' },
            { street: 'main street', suburb: 'CANBERRA', postcode: '2601' },
            { street: 'bunda street', suburb: 'CANBERRA', postcode: '2601' }
        ];

        const match = actMap.find(m => full.includes(m.street));
        if (match) {
            if (!components.suburb) components.suburb = match.suburb;
            if (!components.postcode) components.postcode = match.postcode;
            if (!components.state) components.state = 'ACT';
        }
    }

    // 3. STRING DEEP-SCAN FALLBACK (Regex)
    if (formattedAddress && (!components.suburb || !components.postcode)) {
        const stateZipMatch = formattedAddress.match(/([A-Z]{2,3})\s+(\d{4})/);

        if (stateZipMatch) {
            if (!components.state) components.state = stateZipMatch[1];
            if (!components.postcode) components.postcode = stateZipMatch[2];

            const statePart = stateZipMatch[0];
            const partsBeforeState = formattedAddress.split(statePart)[0].split(',');
            let potentialSuburb = partsBeforeState[partsBeforeState.length - 1].trim();

            if (!components.suburb && potentialSuburb) {
                const isJustStreet = components.streetName && potentialSuburb.toLowerCase().includes(components.streetName.toLowerCase());
                if (!isJustStreet) {
                    components.suburb = potentialSuburb;
                }
            }
        }
    }

    return normalizeAddressForVocus(components);
};
